module.exports = __webpack_public_path__ + "media/images/help/delivery/eyecatch-calendar-express-5-319d25f57e50b377ccc0f97a40fb6796.svg";